<template>
  <div class="news-box">
    <p class="title">
      {{ $t("home.introduction.title.text9") }}
    </p>
    <div class="box mt60">
      <div
        class="item"
        v-for="(item, index) in newsList"
        @click="itemClick(item)"
      >
        <!-- <div class="state">{{ item.cateName }}</div> -->
        <img :src="item.image" alt="png" />
        <p class="title1">{{ item.title }}</p>
        <p class="title2">
          <i class="el-icon-time" />
          {{ dateFormatter(new Date(item.createTime), "yyyy-MM-dd hh:mm:ss") }}
        </p>
      </div>
    </div>
    <div class="more-box" @click="$router.push({ path: '/news' })">
      {{ $t("home.introduction.title.text10") }}
    </div>
    <!-- <p class="title3">注册rwa.ltd账号，开启非金融性资产代币交易之旅</p>
    <div class="input-box">
      <el-input
        placeholder="请输入邮箱"
        v-model="inputValue"
        clearable
        style="width: 310px"
      />
      <div class="btn">立即注册</div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      newsList: [],
      inputValue: "",
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  mounted() {
    const _this = this;
    this.$axios
      .post("/cms/getList", {
        page: 0,
        rows: 3,
        cateCode: "news|platform_notice",
      })
      .then((res) => {
        if (res.data.code === this.errorCode.ok) {
          _this.newsList = res.data.data.rows || [];
        }
      });
  },
  methods: {
    itemClick(item) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: item.articleId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.news-box {
  margin-top: 120px;
  .input-box {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin: 60px auto;
    .btn {
      line-height: 48px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      width: 160px;
      height: 48px;
      background: #4063ff;
      border-radius: 12px 12px 12px 12px;
    }
  }
  .title3 {
    margin-top: 120px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 32px;
    color: #333333;
  }
  .box {
    display: flex;
    gap: 32px;
    justify-content: center;
  }
  .more-box {
    margin: 0 auto;
    width: 315px;
    height: 57px;
    margin-top: 60px;
    line-height: 57px;
    text-align: center;
    cursor: pointer;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #4063ff;
    margin-bottom: 120px;
  }
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 36px;
    color: #333333;
    text-align: center;
  }
  .item {
    width: 446px;
    height: 388px;
    overflow: hidden;
    position: relative;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    .state {
      width: 84px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #ffffff;
      position: absolute;
      top: 0;
      left: 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      border-radius: 12px 0px 12px 0px;
    }
    p {
      margin: 20px;
    }
    img {
      width: 446px;
      height: 250px;
      object-fit: cover;
    }
    .title1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 限制为两行 */
      overflow: hidden;
    }
    .title2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
    }
  }
}
</style>
